import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface BonusCardProps {
  title: string;
  value: string;
  description?: string;
  benefits: string[];
  icon: string;
  delay?: number;
  imageUrl?: string;
}
export function BonusCard({
  title,
  value,
  description,
  benefits,
  icon,
  delay = 0,
  imageUrl
}: BonusCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white rounded-xl border border-stone-200 overflow-hidden flex flex-col h-full hover:border-amber-200 hover:shadow-lg transition-all duration-300" data-id="element-174">
      {/* Image Header */}
      {imageUrl && <div className="relative w-full aspect-[3/4] overflow-hidden bg-stone-100" data-id="element-175">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-176" />
        </div>}

      {/* Content Container */}
      <div className="p-6 flex flex-col flex-grow" data-id="element-177">
        <div className="flex justify-between items-start mb-4" data-id="element-178">
          {!imageUrl && <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center text-2xl" data-id="element-179">
              {icon}
            </div>}
          <div className="bg-amber-50 text-amber-800 text-xs font-bold px-3 py-1 rounded-full border border-amber-100 ml-auto" data-id="element-180">
            VALOR: {value}
          </div>
        </div>

        <h3 className="text-lg font-bold text-stone-800 mb-2 leading-tight" data-id="element-181">
          {title}
        </h3>

        {description && <p className="text-stone-600 text-sm mb-4 leading-relaxed" data-id="element-182">
            {description}
          </p>}

        <ul className="space-y-2 mt-auto pt-4 border-t border-stone-100" data-id="element-183">
          {benefits.map((benefit, index) => <li key={index} className="flex items-start text-stone-600 text-sm" data-id="element-184">
              <CheckIcon className="w-4 h-4 text-amber-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-185" />
              <span data-id="element-186">{benefit}</span>
            </li>)}
        </ul>
      </div>
    </motion.div>;
}